const externalInput = document.getElementById("custom-qty-input");
const minusBtn = document.getElementById("custom-qty-minus");
const plusBtn = document.getElementById("custom-qty-plus");

const realInput = document.querySelector("[data-quantity-input]");

function syncToRealInput(value) {
  if (realInput) {
    realInput.value = value;
    externalInput.value = value;
    realInput.dispatchEvent(new Event("input", { bubbles: true }));
    realInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function syncToExternalInput(value) {
  externalInput.value = value;
}

syncToRealInput(realInput?.value || 1);


plusBtn.addEventListener("click", () => {
  let qty = parseInt(externalInput.value, 10) || 1;
  qty++;
  syncToRealInput(qty);
});

minusBtn.addEventListener("click", () => {
  let qty = parseInt(externalInput.value, 10) || 1;
  if (qty > 1) qty--;
  syncToRealInput(qty);
});

externalInput.addEventListener("input", (e) => {
  let qty = Math.max(1, parseInt(e.target.value, 10) || 1);
  syncToRealInput(qty);
});

realInput.addEventListener("input", () => {
  syncToExternalInput(realInput.value);
});
realInput.addEventListener("change", () => {
  syncToExternalInput(realInput.value);
});

document
  .getElementById("external-submit-button")
  .addEventListener("click", function () {
    const nativeAddToCartButton = document.querySelector("[data-add-to-cart]");
    if (nativeAddToCartButton) {
      nativeAddToCartButton.click();
    }
  });
